import { useEffect, useRef } from "react";
import QRCodeLib from "qrcode";

export default function QrCode({ value, size = 140 }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!value || !ref.current) return;
    QRCodeLib.toCanvas(ref.current, value, { width: size, margin: 1 }, (err) => {
      if (err) console.error("QR render", err);
    });
  }, [value, size]);

  return <canvas ref={ref} style={{ width: size, height: size }} />;
}
